import { createUseStyles } from 'react-jss'
import { DARK_GRAY_11, DARK_GRAY_05 } from '@styles/colors'
import { FONT_MEDIUM } from '@styles/fonts'

export default createUseStyles({
  accountName: {
    color: 'var(--body__text__color)',
    fontFamily: FONT_MEDIUM,
    fontSize: '15px',
    lineHeight: '13px'
  },
  container: {
    borderRadius: '5px',
    boxShadow: `0px 0px 3px ${DARK_GRAY_05}, 0px 4px 15px ${DARK_GRAY_11}`,
    display: 'flex',
    flexDirection: 'column',
    margin: '20px',
    overflowY: 'auto',
    textAlign: 'center'
  },
  messageBody: {
    backgroundColor: 'var(--secondary__page__background__color)',
    padding: '40px',
    textAlign: 'center'
  },
  messageDate: {
    color: 'var(--message__date__text__color)',
    fontFamily: FONT_MEDIUM,
    fontSize: '13px',
    lineHeight: '25px'
  },
  messageDescription: {
    color: 'var(--body__text__color)',
    display: 'flex',
    fontSize: '15px',
    justifyContent: 'center',
    lineHeight: '20px',
    textAlign: 'left',
    whiteSpace: 'pre-line',
    width: '100%',
    wordBreak: 'break-word'
  },
  messageHeader: {
    backgroundColor: 'var(--message__header__background__color)',
    borderBottom: '1px solid var(--message__header__border__color)',
    dispay: 'flex',
    justifyContent: 'center',
    padding: '15px'
  },
  messageSubject: {
    color: 'var(--title__text__color)',
    fontFamily: FONT_MEDIUM,
    fontSize: '28px',
    marginBottom: '30px',
    whiteSpace: 'pre-line',
    wordBreak: 'break-word'
  },
  text: {
    '& a': {
      color: 'var(--link__text__color)',
      textDecoration: 'underline'
    }
  }
})
